import { useThree } from '@react-three/fiber'
import { useEffect } from 'react'

export default function StabPerformance() {
  const { gl } = useThree()

  useEffect(() => {
    const apply = () => {
      const isMobile = window.matchMedia('(pointer: coarse)').matches
      const maxDpr = isMobile ? 1 : 1.5
      const dpr = Math.min(window.devicePixelRatio || 1, maxDpr)
      gl.setPixelRatio(dpr)
    }

    apply()
    window.addEventListener('resize', apply)
    return () => window.removeEventListener('resize', apply)
  }, [gl])
  return null
}
